import { indexForPosition } from './insertBoardObject'
import { type BoardObjectsTransform } from './types'

export const moveBoardObject =
  (boardObjectId: string, position: number): BoardObjectsTransform =>
  (draft) => {
    const moved = draft.data.find((bo) => bo.id === boardObjectId)
    if (!moved) return draft

    const others = draft.data
      .filter((bo) => bo.id !== boardObjectId)
      .sort((a, b) => a.attributes.position - b.attributes.position)

    moved.attributes.position = position
    others.splice(
      indexForPosition(
        others.map((bo) => bo.attributes.position),
        position
      ),
      0,
      moved
    )
    draft.data = others
    return draft
  }
